import { render } from "./welcome.vue?vue&type=template&id=64dd2655&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"

import "./welcome.vue?vue&type=style&index=0&id=64dd2655&lang=scss&scoped=true"
import "./welcome.vue?vue&type=style&index=1&id=64dd2655&lang=scss"
script.render = render
script.__scopeId = "data-v-64dd2655"

export default script